import axios from 'axios';
import { MailingK } from "../types/mailingk.type";

const API_URL = process.env.REACT_APP_API_URL;

export const getMailings = async (): Promise<MailingK[]> => {
    try {
        const { data } = await axios.get<MailingK[]>(`${API_URL}k/mailings`);
        return data;
    } catch (error) {
        console.error('Error fetching mailings:', error);
        throw error;
    }
};
